import * as yup from 'yup';

import { REQUIRED } from '../../forms/errorsText';

export const validationFields = {
  storeId: yup.string().required(REQUIRED),
  date: yup.date().required(REQUIRED),
  place: yup.string().required(REQUIRED),
  amount: yup.number(),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = (cashbackParams) => {
  const { storeId, date, place, amount } = cashbackParams;
  return {
    storeId,
    date,
    place,
    amount,
  };
};
